/**
 * Created by Mike Naughton on 10/17/17.
 *
 * Operations relating to managing security for various entities
 */

import $ from "jquery";
import Operation from "core/models/Operation";
import OperationSet from "core/models/OperationSet";
import GroupCollection from "app/models/GroupCollection";
import SecurityEditor from "app/views/admin/permissions/Editor";
import modals from "core/views/modals";

export default new OperationSet([
  new Operation({
    id: "manage-security",
    text: "Manage Security",
    icon: "lock",
    action: function (model, options) {
      var deferred = new $.Deferred();

      var groups = new GroupCollection([]);

      options = options || {}; //are there any reasonable defaults here?

      groups.fetch({
        success: function () {
          var editor = new SecurityEditor({
            groups: groups.models,
            type: options.type,
            actions: options.actions,
            allowAllUsers: options.allowAllUsers !== false,
          });

          editor.render();
          modals.alert("Manage Security", editor.$el, "Done", function () {
            deferred.resolve(model);
          });
        },
        error: function (collection, response) {
          deferred.reject(response);
        },
      });

      return deferred.promise();
    },
  }),
]);



//////////////////
// WEBPACK FOOTER
// ./public/js/app/operations/map/SecurityOperations.js
// module id = 914
// module chunks = 1